import { toast } from 'sonner';
import { isApiError } from '@/api/errors';
import { getErrorMessage, isReportable, logError } from '@/utils/errors/apiErrors';
import { SupportReportButton } from '@/components/Errors/SupportReportButton';

function categoryIsReportable(err: unknown): boolean {
  return isApiError(err) && isReportable(err.errorCategory);
}

export function toastApiError(err: unknown, defaultMessage: string): void {
  const message = getErrorMessage(err, defaultMessage);

  if (isApiError(err) && err.status >= 500) {
    logError('api', err);
    toast.error(message, {
      duration: Infinity,
      action: <SupportReportButton error={err} />,
    });
    return;
  }

  if (categoryIsReportable(err)) {
    toast.error(message, {
      duration: Infinity,
      action: <SupportReportButton error={err} />,
    });
    return;
  }

  toast.error(message);
}
